import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage } from 'react-intl'
import styles from './field-error.styl'

export default class FieldError extends Component {
  static propTypes = {
    toShow: PropTypes.any,
    message: PropTypes.any,
    className: PropTypes.string,
  }

  render() {
    const { toShow, message, className } = this.props

    return (
      <span className={`${styles.error} ${toShow ? styles.active : ''} ${className}`}>
        {message && message.intlKey ? (
          <FormattedHTMLMessage
            id={message.intlKey}
            defaultMessage={message.text}
            values={message.values}
          />
        ) : get(message, 'text')}
      </span>
    )
  }
}
